import isObjectLike from 'lodash/isObjectLike';
import React, {useMemo} from 'react';
import {Link} from 'react-router-dom';

export default function ColumnComponent({column, href, data}) {
  const content = useMemo(() => {
    if (column.Component)
      return (
        <column.Component
          column={column}
          rawValue={column.rawValue}
          formattedValue={column.formattedValue}
          data={data}
        />
      );
    else {
      const value = column.formattedValue || column.rawValue;
      if (isObjectLike(value)) {
        // Defensive fallback: a malformed/partial object slipped past the
        // column's format() function (returned falsy) AND the raw value is
        // still an object. Rendering JSON.stringify(...) produced visible
        // literals like `{"phone":null}` in the jobs list when a trip's
        // driver field was written with missing firstName/nickName. Show
        // an em-dash placeholder instead and log once so we can trace the
        // upstream source without the UI looking broken.
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('[ColumnComponent] Object-like value with no formatter output:', column?.path, value);
        }
        return '—';
      } else {
        return value;
      }
    }
  }, [column, data]);

  const style = useMemo(() => ({width: column.width}), [column]);

  const result = useMemo(
    () =>
      href ? (
        href.startsWith('http') ? (
          <a href={href} className="firestore-column" style={style}>
            {content || <>&nbsp;</>}
          </a>
        ) : (
          <Link to={href} className="firestore-column" style={style}>
            {content || <>&nbsp;</>}
          </Link>
        )
      ) : (
        <div className="firestore-column" style={style}>
          {content}
        </div>
      ),
    [content, style, href],
  );

  return result;
}
